export default "__VITE_ASSET__SZnyuc3l__"